import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';

import './SingleNutrientDetailsTable.css';

/**
 * Concerns of this component:
 *   render the component details table
 *   based on given component props
**/
class SingleNutrientDetailsTable extends Component {
  render() {
    const { component } = this.props;
    if (!component) { return null; }

    let altnames = component.altnames;
    if(!Array.isArray(altnames) || altnames.length === 0) {
      altnames = '';
    } else if(altnames.length === 1) {
      altnames = altnames[0];
    } else {
      altnames = <ul>{altnames.map((altname, i) => <li key={i}>{altname}</li>)}</ul>;
    }

    return (
      <div className="SingleNutrientDetailsTable">
        <h4>{component.display_name}</h4>
        <Table condensed>
          <tbody>
            {/* <tr>
              <th>Nutrient description</th>
              <td>{component.description || ''}</td>
            </tr> */}
            <tr>
              <th>Alternate name(s)</th>
              <td>{altnames}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }
}

SingleNutrientDetailsTable.propTypes = {
  component: PropTypes.object,
};

export default SingleNutrientDetailsTable;



// WEBPACK FOOTER //
// ./src/components/search/singleNutrient/SingleNutrientDetailsTable.js